import { Injectable, ElementRef, Inject } from '@angular/core';
import { Observable, Subject, fromEvent, interval, merge } from 'rxjs';
import { throttle, debounce, takeUntil, debounceTime, throttleTime, auditTime, filter } from 'rxjs/operators';
import { PLATFORM_ID } from '@angular/core';
 import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ScrollspyService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  spyOffset(scrollOffset: number, scrollDebounceTime: number = 250): Observable<any> {

    if (isPlatformServer(this.platformId)) return;

    const observer = new Observable( (obsrv) => {

      let lastScrollFlag = false;

      // initialy setting flag
      obsrv.next(lastScrollFlag = (scrollOffset < document.documentElement.scrollTop) );

      merge(
        fromEvent(document, 'scroll'),
        fromEvent(window, 'resize')
      )
      .pipe(auditTime(scrollDebounceTime))
      .subscribe(() => {

        if (scrollOffset < document.documentElement.scrollTop) {
          if (lastScrollFlag === false) { lastScrollFlag = true; obsrv.next(true); }
        } else {
          if (lastScrollFlag === true) { lastScrollFlag = false; obsrv.next(false); }
        }

      });
    });

    return observer;
  }

  spyNativeElements(offsetElements: Array<HTMLElement>) {

    if (isPlatformServer(this.platformId)) return;

    const observer = new Observable( (observer) => {

      var lastActiveElement = -1;

      merge(
        fromEvent(document, 'scroll'),
        fromEvent(window, 'resize')
      ).subscribe(() => {

        var elementIndex = -1;

        offsetElements.forEach( (element, index) => {          
            const elementState = this.checkElementInViewport(element, 33);
            if( elementState?.isAboveTheFold && elementState?.element)  elementIndex = index; 
        });

        if(elementIndex == -1) return;
        if(lastActiveElement != elementIndex) observer.next( elementIndex ); 
        lastActiveElement = elementIndex;
      });

    });

    return observer;
  }

  spyElement(OffsetElement: ElementRef): Observable<any> {

    if (isPlatformServer(this.platformId)) return;
    return this.spyNativeElement(OffsetElement.nativeElement);

  }

  spyNativeElement(OffsetElement: HTMLElement, id?) {

    if (isPlatformServer(this.platformId)) return;

    const observer = new Observable( (obsrv) => {

      let lastCheckResult = this.checkElementInViewport(OffsetElement);

      // initialy setting flag
      //const firstElementBoundaries = OffsetElement.getBoundingClientRect();
      obsrv.next( lastCheckResult );

      merge(
        fromEvent(document, 'scroll'),
        fromEvent(window, 'resize')
      ).subscribe(() => {

        const windowHeight = window.outerHeight;

        var checkResult = this.checkElementInViewport(OffsetElement);

        if ( this.checkIfViewportStateChanged(checkResult, lastCheckResult) ) {
          obsrv.next( checkResult ); 
          lastCheckResult = checkResult;
        }

      });
    });

    return observer;

  }

  checkElementInViewport(element: HTMLElement, foldPositionPercentage?: number) {

    if (!element) return;
    if (!window) return;
    
    if(foldPositionPercentage == undefined) foldPositionPercentage = 50;
    foldPositionPercentage = foldPositionPercentage / 100;

    var rect = element.getBoundingClientRect();
    var topIsInViewport = rect.top <= window.innerHeight && rect.top > 0;
    var bottomIsInViewport = rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.bottom >= 0;
    var isInViewport = (
      !(rect.top < 0 && rect.bottom < 0) && 
      (
        rect.top <= window.innerHeight ||
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      )
    );

    // Calculate how many percent of the viewport is filled with our element
    var percentageOfViewport = 0;
    if(rect.top < 0 && rect.bottom - window.innerHeight > 0) {
      percentageOfViewport = 100;
    } else if (rect.top > 0 && rect.bottom - window.innerHeight < 0) {
      percentageOfViewport = (rect.bottom - rect.top) / window.innerHeight * 100;
    } else if(rect.top > 0) {
      percentageOfViewport = (rect.height - (rect.bottom - window.innerHeight)) / window.innerHeight * 100;
    } else {
      percentageOfViewport = (rect.height + rect.top) / window.innerHeight * 100;
    }
    if(percentageOfViewport < 0) percentageOfViewport = 0;
    var percentageOfViewport = Math.round(percentageOfViewport);
    
    // Calculate Above the Fold Flag
    var isAboveTheFold = rect.top < window.innerHeight * foldPositionPercentage;

    var isAboveViewport = rect.top < 0;
    var isBelowViewport = rect.top > window.innerHeight;

    //if(element.id=="testnav") console.log(rect, window.innerHeight);

    return {
      'top': topIsInViewport,
      'bottom': bottomIsInViewport,
      'element': isInViewport,
      'percentageOfViewport': percentageOfViewport,
      'isAboveTheFold': isAboveTheFold,
      'isAboveViewport': isAboveViewport,
      'isBelowViewport': isBelowViewport
    };
  }

  checkIfViewportStateChanged(state1, state2) : boolean {

      return !(
        state1.top == state2.top 
        && state1.bottom == state2.bottom
        && state1.element == state2.element
        && state1.isAboveTheFold == state2.isAboveTheFold
        && state1.isAboveViewport == state2.isAboveViewport
        && state1.isBelowViewport == state2.isBelowViewport
      );

  }

  


}
